import { LOCALE } from "@kivunova/kivufrontendcommon";

/**
 * Set when the user picks a locale in LanguageSelector, before URL navigation
 * finishes. Lets LanguageLayout normalize the path without URL-over-context
 * reverting the selection on the next effect pass.
 */
let pendingUserLocale: LOCALE | null = null;

export const markUserLocaleSwitch = (locale: LOCALE): void => {
  pendingUserLocale = locale;
};

export const peekUserLocaleSwitch = (): LOCALE | null => pendingUserLocale;

export const clearUserLocaleSwitch = (): void => {
  pendingUserLocale = null;
};
